// extracted by mini-css-extract-plugin
module.exports = {"majorContainer":"LandingPage_majorContainer__3Jgs8"};